import { FacetFilter, FacetFilterType, useFacetsFilters } from '@/app/composable';
import store from '@/app/store';
import { AssetTypeId } from '@/modules/asset/constants';
import { computed } from '@vue/composition-api';
import { ExpectedUsage, ExpectedUsageText, ReimbursementMethod, ReimbursementMethodText } from '../constants';

export function useMarketplaceFacets(get: any) {
    const domains = computed(() => store.getters.dataModel.domains);

    const { valueLabel, reducedFacetsFilters, defaultValue } = useFacetsFilters();

    const marketplaceFacets = computed(
        (): Record<string, FacetFilter> => ({
            domain: {
                label: 'Domain',
                type: FacetFilterType.Checkbox,
                default: defaultValue(get, 'domain'),
                valueLabel: (uid: string) => {
                    const domain = domains.value.find((dom: any) => dom.uid === uid);
                    return domain ? domain.name : uid;
                },
            },
            organisationType: {
                label: 'Data Provider Type',
                type: FacetFilterType.Checkbox,
                default: defaultValue(get, 'organisationType'),
                valueLabel,
            },
        }),
    );

    const reducedMarketplaceFacets: any = reducedFacetsFilters(marketplaceFacets);

    return { marketplaceFacets, reducedMarketplaceFacets };
}
